import type { ResolveWidgetVehicleResponse, WidgetFuel } from '../types/PublicBookingChannelTypes'

/** The fuel as a customer reads it (ACA-125). UNKNOWN is left unsaid. */
const FUEL_WORDS: Record<WidgetFuel, string | null> = {
  PETROL: 'Petrol',
  DIESEL: 'Diesel',
  HYBRID: 'Hybrid',
  PLUG_IN_HYBRID: 'Plug-in hybrid',
  ELECTRIC: 'Electric',
  UNKNOWN: null,
}

type VehicleFacts = Pick<
  ResolveWidgetVehicleResponse,
  'vehicleMake' | 'vehicleModel' | 'engineDescription' | 'fuel'
>

/**
 * How the vehicle confirmation names the car: make and model, then the engine
 * and fuel when the lookup knew them, e.g. "BMW 3 Series · 3.0 Petrol".
 */
export function vehicleSummary(vehicle: VehicleFacts): string {
  const name = [vehicle.vehicleMake, vehicle.vehicleModel]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ')
  const fuel = vehicle.fuel ? FUEL_WORDS[vehicle.fuel] ?? null : null
  const detail = [vehicle.engineDescription?.trim(), fuel].filter(Boolean).join(' ')
  if (!detail) return name
  return name ? `${name} · ${detail}` : detail
}
